"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _SectionRowInventories = _interopRequireDefault(require("@/flow/plantNursery/components/SectionRowInventories.vue"));
var _plantNursery = require("@/services/plant-nursery.service");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var _default2 = exports.default = {
  name: 'EditLotModal',
  components: {
    SectionRowInventories: _SectionRowInventories.default
  },
  props: {
    isModalActive: {
      type: Boolean,
      default: false
    },
    isSaving: {
      type: Boolean,
      default: false
    },
    lot: {
      type: Object,
      default: function _default() {
        return null;
      }
    }
  },
  data: function data() {
    return {
      form: this.createDefaultForm(),
      isSubmitting: false,
      isLoadingOperations: false,
      operations: []
    };
  },
  mounted: function mounted() {
    this.fetchOperations();
  },
  watch: {
    isModalActive: function isModalActive(active) {
      if (active) {
        this.resetForm();
        this.fetchOperations();
      }
    },
    lot: {
      handler: function handler() {
        this.resetForm();
      }
    }
  },
  computed: {},
  methods: {
    createDefaultForm: function createDefaultForm() {
      var _this$lot, _ref, _this$lot$name, _this$lot2, _this$lot3, _this$lot4;
      var createdAt = (_this$lot = this.lot) !== null && _this$lot !== void 0 && _this$lot.date ? new Date(this.lot.date) : new Date();
      return {
        name: (_ref = (_this$lot$name = (_this$lot2 = this.lot) === null || _this$lot2 === void 0 ? void 0 : _this$lot2.name) !== null && _this$lot$name !== void 0 ? _this$lot$name : (_this$lot3 = this.lot) === null || _this$lot3 === void 0 ? void 0 : _this$lot3.code) !== null && _ref !== void 0 ? _ref : '',
        createdAt: createdAt,
        inventories: this.createInventoriesPayload((_this$lot4 = this.lot) === null || _this$lot4 === void 0 ? void 0 : _this$lot4.inventories)
      };
    },
    createInventoriesPayload: function createInventoriesPayload(inventories) {
      if (!Array.isArray(inventories) || !inventories.length) {
        return [];
      }
      return inventories.map(function (inv) {
        var _ref2, _inv$section$id, _inv$section, _inv$row, _inv$row$id, _inv$row2, _inv$id;
        return {
          sectionId: (_ref2 = (_inv$section$id = inv === null || inv === void 0 ? void 0 : (_inv$section = inv.section) === null || _inv$section === void 0 ? void 0 : _inv$section.id) !== null && _inv$section$id !== void 0 ? _inv$section$id : inv === null || inv === void 0 ? void 0 : (_inv$row = inv.row) === null || _inv$row === void 0 ? void 0 : _inv$row.sectionId) !== null && _ref2 !== void 0 ? _ref2 : null,
          rowId: (_inv$row$id = inv === null || inv === void 0 ? void 0 : (_inv$row2 = inv.row) === null || _inv$row2 === void 0 ? void 0 : _inv$row2.id) !== null && _inv$row$id !== void 0 ? _inv$row$id : null,
          quantity: typeof (inv === null || inv === void 0 ? void 0 : inv.quantity) === 'number' ? inv.quantity : null,
          inventoryId: (_inv$id = inv === null || inv === void 0 ? void 0 : inv.id) !== null && _inv$id !== void 0 ? _inv$id : null
        };
      });
    },
    resetForm: function resetForm() {
      this.form = this.createDefaultForm();
    },
    handleClose: function handleClose() {
      this.resetForm();
      this.$emit('onClose');
    },
    fetchOperations: function () {
      var _fetchOperations = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _this$lot5;
        var params, _yield$plantNurserySe, response, items, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              if ((_this$lot5 = this.lot) !== null && _this$lot5 !== void 0 && _this$lot5.id) {
                _context.n = 1;
                break;
              }
              this.operations = [];
              return _context.a(2);
            case 1:
              this.isLoadingOperations = true;
              _context.p = 2;
              params = {
                page: 1,
                limit: 200,
                receiverLotId: this.lot.id
              };
              _context.n = 3;
              return _plantNursery.plantNurseryService.fetchLotOperations(this.lot.id, params);
            case 3:
              _yield$plantNurserySe = _context.v;
              response = _yield$plantNurserySe.data;
              items = Array.isArray(response === null || response === void 0 ? void 0 : response.data) ? response.data : [];
              this.operations = items;
              _context.n = 5;
              break;
            case 4:
              _context.p = 4;
              _t = _context.v;
              this.operations = [];
            case 5:
              _context.p = 5;
              this.isLoadingOperations = false;
              return _context.f(5);
            case 6:
              return _context.a(2);
          }
        }, _callee, this, [[2, 4, 5, 6]]);
      }));
      function fetchOperations() {
        return _fetchOperations.apply(this, arguments);
      }
      return fetchOperations;
    }(),
    formatOperationType: function formatOperationType(value) {
      var types = {
        transfer: 'Transferência',
        move: 'Movimentação',
        merge: 'Junção',
        graft: 'Enxertia',
        partial_graft: 'Enxertia parcial',
        graft_sucess_rate: 'Mortalidade da copa',
        regraft: 'Re-enxertia',
        cutting: 'Estaquia'
      };
      return types[value] || value || '--';
    },
    formatQuantity: function formatQuantity(value) {
      if (typeof value === 'number' && !Number.isNaN(value)) return value;
      if (typeof value === 'string' && value.trim() !== '') {
        var parsed = Number(value);
        return Number.isNaN(parsed) ? '--' : parsed;
      }
      return '--';
    },
    formatDate: function formatDate(value) {
      if (!value) return '--';
      var date = value instanceof Date ? value : new Date(value);
      if (Number.isNaN(date.getTime())) return '--';
      return date.toLocaleDateString('pt-BR');
    },
    submitForm: function () {
      var _submitForm = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _this$lot6;
        var inventories, i, _inv$quantity, inv, quantity, payload, _error$response, _error$response$data, message, _t2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              inventories = Array.isArray(this.form.inventories) ? this.form.inventories : [];
              if (inventories.length) {
                _context2.n = 1;
                break;
              }
              this.$buefy.toast.open({
                message: 'Adicione pelo menos um local.',
                type: 'is-danger'
              });
              return _context2.a(2);
            case 1:
              i = 0;
            case 2:
              if (!(i < inventories.length)) {
                _context2.n = 5;
                break;
              }
              inv = inventories[i];
              if (inv.rowId) {
                _context2.n = 3;
                break;
              }
              this.$buefy.toast.open({
                message: "Selecione a rua para o local ".concat(i + 1, "."),
                type: 'is-danger'
              });
              return _context2.a(2);
            case 3:
              quantity = Number((_inv$quantity = inv.quantity) !== null && _inv$quantity !== void 0 ? _inv$quantity : 0);
              if (!(!Number.isFinite(quantity) || quantity <= 0)) {
                _context2.n = 4;
                break;
              }
              this.$buefy.toast.open({
                message: "Informe a quantidade para o local ".concat(i + 1, "."),
                type: 'is-danger'
              });
              return _context2.a(2);
            case 4:
              i++;
              _context2.n = 2;
              break;
            case 5:
              payload = {
                date: this.form.createdAt,
                inventories: inventories.map(function (inv) {
                  return {
                    rowId: inv.rowId,
                    sectionId: inv.sectionId,
                    quantity: inv.quantity,
                    inventoryId: inv.inventoryId
                  };
                })
              };
              if ((_this$lot6 = this.lot) !== null && _this$lot6 !== void 0 && _this$lot6.id) {
                _context2.n = 6;
                break;
              }
              return _context2.a(2);
            case 6:
              this.isSubmitting = true;
              _context2.p = 7;
              _context2.n = 8;
              return _plantNursery.plantNurseryService.updateLot(this.lot.id, payload);
            case 8:
              this.$buefy.toast.open({
                message: 'Lote atualizado com sucesso.',
                type: 'is-success'
              });
              this.$emit('submit', payload);
              _context2.n = 10;
              break;
            case 9:
              _context2.p = 9;
              _t2 = _context2.v;
              message = (_t2 === null || _t2 === void 0 ? void 0 : (_error$response = _t2.response) === null || _error$response === void 0 ? void 0 : (_error$response$data = _error$response.data) === null || _error$response$data === void 0 ? void 0 : _error$response$data.message) || (_t2 === null || _t2 === void 0 ? void 0 : _t2.message) || 'Não foi possível atualizar o lote.';
              this.$buefy.toast.open({
                message: message,
                type: 'is-danger'
              });
            case 10:
              _context2.p = 10;
              this.isSubmitting = false;
              return _context2.f(10);
            case 11:
              return _context2.a(2);
          }
        }, _callee2, this, [[7, 9, 10, 11]]);
      }));
      function submitForm() {
        return _submitForm.apply(this, arguments);
      }
      return submitForm;
    }(),
    handleDeleteLot: function () {
      var _handleDeleteLot = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var _this = this;
        var lot, _t3;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              lot = this.lot;
              if (lot !== null && lot !== void 0 && lot.id) {
                _context4.n = 1;
                break;
              }
              return _context4.a(2);
            case 1:
              _context4.p = 1;
              _context4.n = 2;
              return this.$buefy.dialog.confirm({
                title: 'Remover lote',
                message: "Deseja realmente remover o lote ".concat(lot.code || '', "?"),
                confirmText: 'Remover',
                cancelText: 'Cancelar',
                type: 'is-danger',
                hasIcon: true,
                onConfirm: function () {
                  var _onConfirm = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
                    return _regenerator().w(function (_context3) {
                      while (1) switch (_context3.n) {
                        case 0:
                          _context3.n = 1;
                          return _plantNursery.plantNurseryService.deleteLot(lot.id);
                        case 1:
                          _this.$buefy.toast.open({
                            message: 'Lote removido com sucesso.',
                            type: 'is-success'
                          });
                          _this.$emit('submit');
                        case 2:
                          return _context3.a(2);
                      }
                    }, _callee3);
                  }));
                  function onConfirm() {
                    return _onConfirm.apply(this, arguments);
                  }
                  return onConfirm;
                }()
              });
            case 2:
              _context4.n = 4;
              break;
            case 3:
              _context4.p = 3;
              _t3 = _context4.v;
              this.$buefy.toast.open({
                message: (_t3 === null || _t3 === void 0 ? void 0 : _t3.message) || 'Não foi possível remover o lote.',
                type: 'is-danger'
              });
            case 4:
              return _context4.a(2);
          }
        }, _callee4, this, [[1, 3]]);
      }));
      function handleDeleteLot() {
        return _handleDeleteLot.apply(this, arguments);
      }
      return handleDeleteLot;
    }()
  }
};